function getFocusableElements(e) {
    return Array.from(
        e.querySelectorAll(
            "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object"
        )
    );
}
const trapFocusHandlers = {},
    warningTime = 3e3;
function trapFocus(e, t = e) {
    var n = getFocusableElements(e),
        i = n[0],
        o = n[n.length - 1];
    removeTrapFocus(),
        (trapFocusHandlers.focusin = (t) => {
            (t.target !== e && t.target !== o && t.target !== i) ||
                document.addEventListener("keydown", trapFocusHandlers.keydown);
        }),
        (trapFocusHandlers.focusout = function () {
            document.removeEventListener("keydown", trapFocusHandlers.keydown);
        }),
        (trapFocusHandlers.keydown = function (t) {
            "TAB" === t.code.toUpperCase() &&
                (t.target !== o || t.shiftKey || (t.preventDefault(), i.focus()),
                (t.target !== e && t.target !== i) || !t.shiftKey || (t.preventDefault(), o.focus()));
        }),
        document.addEventListener("focusout", trapFocusHandlers.focusout),
        document.addEventListener("focusin", trapFocusHandlers.focusin),
        t.focus();
}
function pauseAllMedia() {
    document.querySelectorAll(".js-youtube").forEach((e) => {
        e.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', "*");
    }),
        document.querySelectorAll(".js-vimeo").forEach((e) => {
            e.contentWindow.postMessage('{"method":"pause"}', "*");
        }),
        document.querySelectorAll("video").forEach((e) => e.pause()),
        document.querySelectorAll("product-model").forEach((e) => e.modelViewerUI?.pause());
}
function removeTrapFocus(e = null) {
    document.removeEventListener("focusin", trapFocusHandlers.focusin),
        document.removeEventListener("focusout", trapFocusHandlers.focusout),
        document.removeEventListener("keydown", trapFocusHandlers.keydown),
        e && e.focus();
}
function debounce(e, t) {
    let n;
    return (...i) => {
        clearTimeout(n), (n = setTimeout(() => e.apply(this, i), t));
    };
}
const serializeForm = (e) => {
    const t = {},
        n = new FormData(e);
    for (const e of n.keys()) t[e] = n.get(e);
    return JSON.stringify(t);
};
function throttle(e, t) {
    let n = 0;
    return function (...i) {
        const o = new Date().getTime();
        if (!(o - n < t)) return (n = o), e(...i);
    };
}
function fetchConfig(e = "json") {
    return { method: "POST", headers: { "Content-Type": "application/json", Accept: `application/${e}` } };
}
function extractContent(e) {
    var t = document.createElement("div");
    return (t.innerHTML = e), t.textContent || t.innerText;
}
function getCartUpdate(e, t, n) {
    const i = JSON.stringify({ line: e, quantity: t, sections_url: window.location.pathname });
    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), body: i })
        .then((e) => e.text())
        .then((e) => {
            const t = JSON.parse(e);
            t.errors
                ? showWarning("Error : " + t.errors, warningTime)
                : "function" == typeof n
                  ? n(t)
                  : Shopify.onCartUpdate(t);
        })
        .catch((e) => {
            console.error(e);
        });
}
void 0 === window.Shopify && (window.Shopify = {}),
    (Shopify.bind = function (e, t) {
        return function () {
            return e.apply(t, arguments);
        };
    }),
    (Shopify.setSelectorByValue = function (e, t) {
        for (var n = 0, i = e.options.length; n < i; n++) {
            var o = e.options[n];
            if (t == o.value || t == o.innerHTML) return (e.selectedIndex = n), n;
        }
    }),
    (Shopify.addListener = function (e, t, n) {
        e.addEventListener ? e.addEventListener(t, n, !1) : e.attachEvent("on" + t, n);
    }),
    (Shopify.postLink = function (e, t) {
        var n = (t = t || {}).method || "post",
            i = t.parameters || {},
            o = document.createElement("form");
        for (var s in (o.setAttribute("method", n), o.setAttribute("action", e), i)) {
            var r = document.createElement("input");
            r.setAttribute("type", "hidden"),
                r.setAttribute("name", s),
                r.setAttribute("value", i[s]),
                o.appendChild(r);
        }
        document.body.appendChild(o), o.submit(), document.body.removeChild(o);
    }),
    (Shopify.CountryProvinceSelector = function (e, t, n) {
        (this.countryEl = document.getElementById(e)),
            (this.provinceEl = document.getElementById(t)),
            (this.provinceContainer = document.getElementById(n.hideElement || t)),
            Shopify.addListener(this.countryEl, "change", Shopify.bind(this.countryHandler, this)),
            this.initCountry(),
            this.initProvince();
    }),
    (Shopify.CountryProvinceSelector.prototype = {
        initCountry: function () {
            var e = this.countryEl.getAttribute("data-default");
            Shopify.setSelectorByValue(this.countryEl, e), this.countryHandler();
        },
        initProvince: function () {
            var e = this.provinceEl.getAttribute("data-default");
            e && this.provinceEl.options.length > 0 && Shopify.setSelectorByValue(this.provinceEl, e);
        },
        countryHandler: function (e) {
            var t = (o = this.countryEl.options[this.countryEl.selectedIndex]).getAttribute("data-provinces"),
                n = JSON.parse(t);
            if ((this.clearOptions(this.provinceEl), n && 0 == n.length)) this.provinceContainer.style.display = "none";
            else {
                for (var i = 0; i < n.length; i++) {
                    var o;
                    ((o = document.createElement("option")).value = n[i][0]),
                        (o.innerHTML = n[i][1]),
                        this.provinceEl.appendChild(o);
                }
                this.provinceContainer.style.display = "";
            }
        },
        clearOptions: function (e) {
            for (; e.firstChild; ) e.removeChild(e.firstChild);
        },
        setOptions: function (e, t) {
            var n = 0;
            for (t.length; n < t.length; n++) {
                var i = document.createElement("option");
                (i.value = t[n]), (i.innerHTML = t[n]), e.appendChild(i);
            }
        },
    }),
    (Shopify.formatMoney = function (e, t) {
        "string" == typeof e && (e = e.replace(".", ""));
        var n = "",
            i = /\{\{\s*(\w+)\s*\}\}/,
            o = t || this.money_format;
        function s(e, t) {
            return void 0 === e ? t : e;
        }
        function r(e, t, n, i) {
            if (((t = s(t, 2)), (n = s(n, ",")), (i = s(i, ".")), isNaN(e) || null == e)) return 0;
            var o = (e = (e / 100).toFixed(t)).split(".");
            return o[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + n) + (o[1] ? i + o[1] : "");
        }
        switch (o.match(i)[1]) {
            case "amount":
                n = r(e, 2);
                break;
            case "amount_no_decimals":
                n = r(e, 0);
                break;
            case "amount_with_comma_separator":
                n = r(e, 2, ".", ",");
                break;
            case "amount_no_decimals_with_comma_separator":
                n = r(e, 0, ".", ",");
        }
        return o.replace(i, n);
    }),
    (Shopify.getCart = function (e) {
        $.getJSON("/cart.js", function (t, n) {
            "function" == typeof e ? e(t) : Shopify.onCartUpdate(t);
        });
    }),
    (Shopify.onCartUpdate = function (e) {
        alert("There are now " + e.item_count + " items in the cart.");
    }),
    (Shopify.changeItem = function (e, t, n, i) {
        getCartUpdate(n, t, i);
    }),
    (Shopify.removeItem = function (e, t, n) {
        getCartUpdate(t, 0, n);
    }),
    (Shopify.addItem = function (e, t, n, i, o = null) {
        let s = "quantity=" + (t = t || 1) + "&id=" + e;
        if (n.closest("form")) {
            const e = n.closest("form").find('[name^="properties"]');
            e.length &&
                e.each((e, t) => {
                    s = `${s}&${$(t).attr("name")}=${$(t).val()}`;
                });
        }
        var r = {
            type: "POST",
            url: "/cart/add.js",
            data: s,
            dataType: "json",
            success: function (e) {
                "function" == typeof i ? i(e) : Shopify.onItemAdded(e);
            },
            error: function (e, t) {
                var i = window.cartStrings.addProductOutQuantity2;
                if (o.length > 0) {
                    var s = parseInt(o.attr("data-inventory-quantity"));
                    (i = getInputMessage(s)), o.val(s);
                }
                Shopify.onError(e, t, i), n.removeClass("is-loading");
            },
        };
        $.ajax(r);
    }),
    (Shopify.onItemAdded = function (e) {
        alert(e.title + " was added to your shopping cart.");
    }),
    (Shopify.onError = function (XMLHttpRequest, textStatus, message) {
        var data = eval("(" + XMLHttpRequest.responseText + ")");
        data.message
            ? data.description
                ? showWarning(data.description)
                : showWarning(data.message + ": " + message, warningTime)
            : showWarning("Error : " + message, warningTime);
    });
class MenuDrawer extends HTMLElement {
    constructor() {
        super(), (this.mainDetailsToggle = this.querySelector("details"));
        const e = this.querySelectorAll("summary");
        this.addAccessibilityAttributes(e),
            "iPhone" === navigator.platform &&
                document.documentElement.style.setProperty("--viewport-height", `${window.innerHeight}px`),
            this.addEventListener("keyup", this.onKeyUp.bind(this)),
            this.addEventListener("focusout", this.onFocusOut.bind(this)),
            this.bindEvents();
    }
    bindEvents() {
        this.querySelectorAll("summary").forEach((e) => e.addEventListener("click", this.onSummaryClick.bind(this))),
            this.querySelectorAll("button").forEach((e) =>
                e.addEventListener("click", this.onCloseButtonClick.bind(this))
            );
    }
    addAccessibilityAttributes(e) {
        e.forEach((e) => {
            e.setAttribute("role", "button"),
                e.setAttribute("aria-expanded", !1),
                e.setAttribute("aria-controls", e.nextElementSibling.id);
        });
    }
    onKeyUp(e) {
        if ("ESCAPE" !== e.code.toUpperCase()) return;
        const t = e.target.closest("details[open]");
        t &&
            (t === this.mainDetailsToggle
                ? this.closeMenuDrawer(this.mainDetailsToggle.querySelector("summary"))
                : this.closeSubmenu(t));
    }
    onSummaryClick(e) {
        const t = e.currentTarget,
            n = t.parentNode,
            i = n.hasAttribute("open");
        n === this.mainDetailsToggle
            ? (i && e.preventDefault(), i ? this.closeMenuDrawer(t) : this.openMenuDrawer(t))
            : (trapFocus(t.nextElementSibling, n.querySelector("button")),
              setTimeout(() => {
                  n.classList.add("menu-opening");
              }));
    }
    openMenuDrawer(e) {
        setTimeout(() => {
            this.mainDetailsToggle.classList.add("menu-opening");
        }),
            e.setAttribute("aria-expanded", !0),
            trapFocus(this.mainDetailsToggle, e),
            document.body.classList.add("overflow-hidden-mobile");
    }
    closeMenuDrawer(e, t = !1) {
        void 0 !== e &&
            (this.mainDetailsToggle.classList.remove("menu-opening"),
            this.mainDetailsToggle.querySelectorAll("details").forEach((e) => {
                e.removeAttribute("open"), e.classList.remove("menu-opening");
            }),
            this.mainDetailsToggle.querySelector("summary").setAttribute("aria-expanded", !1),
            document.body.classList.remove("overflow-hidden-mobile"),
            removeTrapFocus(t),
            this.closeAnimation(this.mainDetailsToggle));
    }
    onFocusOut(e) {
        setTimeout(() => {
            this.mainDetailsToggle.hasAttribute("open") &&
                !this.mainDetailsToggle.contains(document.activeElement) &&
                this.closeMenuDrawer();
        });
    }
    onCloseButtonClick(e) {
        const t = e.currentTarget.closest("details");
        this.closeSubmenu(t);
    }
    closeSubmenu(e) {
        e.classList.remove("menu-opening"), removeTrapFocus(), this.closeAnimation(e);
    }
    closeAnimation(e) {
        let t;
        const n = (i) => {
            void 0 === t && (t = i);
            i - t < 400
                ? window.requestAnimationFrame(n)
                : (e.removeAttribute("open"),
                  e.closest("details[open]") && trapFocus(e.closest("details[open]"), e.querySelector("summary")));
        };
        window.requestAnimationFrame(n);
    }
}
customElements.define("menu-drawer", MenuDrawer);
class HeaderDrawer extends MenuDrawer {
    constructor() {
        super();
    }
    openMenuDrawer(e) {
        (this.header = this.header || document.getElementById("shopify-section-header")),
            (this.borderOffset =
                this.borderOffset || this.closest(".header-wrapper").classList.contains("header-wrapper--border-bottom")
                    ? 1
                    : 0),
            document.documentElement.style.setProperty(
                "--header-bottom-position",
                `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
            ),
            setTimeout(() => {
                this.mainDetailsToggle.classList.add("menu-opening");
            }),
            e.setAttribute("aria-expanded", !0),
            trapFocus(this.mainDetailsToggle, e),
            document.body.classList.add("overflow-hidden-mobile");
    }
}
customElements.define("header-drawer", HeaderDrawer);
class UpdateQuantity extends HTMLElement {
    constructor() {
        super(),
            (this.input = this.querySelector("input")),
            (this.changeCart = !1),
            (this.changeEvent = new Event("change", { bubbles: !0 })),
            this.querySelectorAll(".btn-quantity").forEach((e) =>
                e.addEventListener("click", this.onButtonClick.bind(this))
            );
    }
    onButtonClick(e) {
        e.preventDefault();
        const t = e.target;
        let n = t.parentElement.querySelector(".quantity");
        const i = Number(n.value),
            o = Number(n.dataset.inventoryQuantity),
            s = t.closest(".product-form")?.querySelector("[data-btn-addtocart]");
        let r,
            a = !1;
        const c = (
            document.body.matches(".quickshop-popup-show")
                ? window[`quick_shop_policy_array_${this.input.dataset.product}`]
                : window[`cart_selling_array_${this.dataset.product}`]
        )[
            document.body.matches(".quickshop-popup-show")
                ? this.closest(".productView-options").querySelector('[name="id"]').value
                : this.input.dataset.cartQuantityId
        ];
        if (
            ((a = "false" == s?.dataset.available || null == s?.dataset.available),
            (r = t.matches(".plus") ? i + 1 : t.matches(".minus") ? i - 1 : i),
            r < 0 && (r = 1),
            r > o && a && "deny" == c)
        ) {
            showWarning(getInputMessage(o), warningTime), (r = o);
        }
        (n.value = r),
            "number" == typeof this.changeCart && clearTimeout(this.changeCart),
            (this.changeCart = setTimeout(() => {
                t.matches(".btn-quantity") && this.input.dispatchEvent(this.changeEvent);
            }, 350));
    }
    quantityCheckedToBeContinue() {
        const e = window[`cart_selling_array_${this.dataset.product}`];
        return null != e && "continue" === e[this.querySelector('[name="quantity"]').dataset.cartQuantityId];
    }
}
class UpdateQuantityQuickShop extends HTMLElement {
    constructor() {
        super(),
            (this.input = this.querySelector("input")),
            (this.changeEvent = new Event("change", { bubbles: !0 })),
            this.querySelectorAll(".btn-quantity").forEach((e) =>
                e.addEventListener("click", this.onChangeQuantity.bind(this))
            ),
            this.input.addEventListener("change", this.onChangeQuantity.bind(this));
    }
    onChangeQuantity(e) {
        e.preventDefault();
        const t = e.target;
        let n = t.parentElement.querySelector(".quantity");
        const i = Number(n.value),
            o = Number(n.dataset.inventoryQuantity),
            s = t.closest("[data-quickshop]").querySelector("[data-btn-addtocart]");
        let r;
        if (
            ((r = t.matches(".plus") ? i + 1 : t.matches(".minus") ? i - 1 : i),
            r <= 0 && (r = 1),
            r > o && !s.matches(".button--pre-untrack"))
        ) {
            showWarning(getInputMessage(o), warningTime), (r = o);
        }
        (n.value = r), t.matches(".btn-quantity") && this.input.dispatchEvent(this.changeEvent);
        this.closest("[data-quickshop]").querySelector('form input[type="hidden"]').setAttribute("value", r);
    }
}
class ProductScroller extends HTMLElement {
    constructor() {
        super(),
            (this.container = this.querySelector("[data-drag-container]")),
            (this.dragParent = this.querySelector("[data-drag-parent]")),
            this.initDragToScroll();
    }
    initDragToScroll() {
        var e;
        (e = this.container).clientWidth < e.scrollWidth
            ? this.dragToScroll(this.container)
            : this.dragToScroll(this.dragParent);
    }
    dragToScroll(e) {
        let t,
            n,
            i,
            o = !1;
        e.addEventListener("mousedown", (i) => {
            i.target;
            (o = !0), (t = i.pageX - e.offsetLeft), (n = e.scrollLeft);
        }),
            e.addEventListener("mouseup", () => {
                (o = !1),
                    clearTimeout(i),
                    (i = setTimeout(() => {
                        e.classList.remove("active");
                    }, 150));
            }),
            e.addEventListener("mousemove", (i) => {
                if (!o) return;
                i.preventDefault(), e.classList.contains("active") || e.classList.add("active");
                const s = 1 * (i.pageX - e.offsetLeft - t);
                e.scrollLeft = n - s;
            }),
            e.addEventListener("mouseleave", () => {
                (o = !1),
                    clearTimeout(i),
                    (i = setTimeout(() => {
                        e.classList.remove("active");
                    }, 150));
            });
    }
}
class ImageToFlip extends HTMLElement {
    constructor() {
        super(), (this.imageContainer = this), this.initObserver();
    }
    initObserver() {
        (this.observer = new IntersectionObserver(
            (e, t) => {
                const n = e[0];
                n.isIntersecting && (n.target.classList.add("show"), t.unobserve(n.target));
            },
            { threshold: 0.4 }
        )),
            this.observer.observe(this.imageContainer);
    }
}
function showWarning(e, t = null) {
    window.warningTimeout && clearTimeout(window.warningTimeout);
    (document.getElementById("halo-warning-popup").querySelector("[data-halo-warning-content]").textContent = e),
        document.body.classList.add("has-warning"),
        t &&
            (window.warningTimeout = setTimeout(() => {
                document.body.classList.remove("has-warning");
            }, t));
}
function getInputMessage(e) {
    return window.cartStrings.addProductOutQuantity.replace("[maxQuantity]", e);
}
window.addEventListener("load", () => {
    customElements.define("cart-update-quantity", UpdateQuantity),
        customElements.define("quickshop-update-quantity", UpdateQuantityQuickShop),
        customElements.define("product-scroller", ProductScroller);
});
class FadeInComponent extends HTMLElement {
    constructor() {
        super();
    }
    connectedCallback() {
        this.initObserver();
    }
    initObserver() {
        (this.observer = new IntersectionObserver(
            (e, t) => {
                e[0].isIntersecting && (this.classList.add("fade-in"), t.unobserve(this));
            },
            { threshold: 0.7 }
        )),
            this.observer.observe(this);
    }
}
function loadScrolling() {
    document.querySelectorAll("[data-scrolling]").forEach((e) => {
        "vertical" == e.dataset.scrolling ? this.scrollVertical(e) : this.scrollHorizontal(e);
    });
}
function scrollVertical(e) {
    const t = e.closest(".special-banner__item") || e,
        n = t.getBoundingClientRect().top,
        i = t.getBoundingClientRect().height,
        o = window.innerHeight,
        s = e.scrollHeight / i,
        r = i >= o ? 0 : (o - i) / 2;
    n - r < 0 && n > -1 * i
        ? this.scrollTop(e, (-1 * n + r) * s)
        : n - r >= 0
          ? this.scrollTop(e, 0)
          : this.scrollTop(e, e.scrollHeight);
}
function scrollTop(e, t) {
    e.scrollTo({ top: t, behavior: "smooth" });
}
function scrollHorizontal(e) {
    const t = e.querySelector(".scrolling-text__list--1"),
        n = e.querySelector(".scrolling-text__list--2");
    if (!t) return;
    const i = e.getBoundingClientRect().top,
        o = e.getBoundingClientRect().height,
        s = window.innerHeight,
        r = t.scrollWidth > window.innerWidth ? t.scrollWidth - window.innerWidth : 0,
        a = 2 * t.getBoundingClientRect().height,
        c = o >= s ? 0 : (s - o) / 2,
        l = r / (o / 2 + c - a);
    let u = (-1 * i + c) * l,
        d = (o / 2 - a + c) * l - u;
    i - c < 0 && i - a > (-1 * o) / 2
        ? ((u *= -1), (d *= -1))
        : i - c >= 0
          ? ((u = 0), (d = -1 * r))
          : ((u = -1 * r), (d = 0)),
        t.scrollWidth <= window.innerWidth ? (n.style.justifyContent = "flex-end") : this.translateX(t, n, u, d);
}
function translateX(e, t, n, i) {
    (e.style.transform = `translateX(${n}px)`), (t.style.transform = `translateX(${i}px)`);
}
window.addEventListener("load", () => {
    customElements.define("fade-in-component", FadeInComponent), this.loadScrolling();
}),
    (window.onscroll = () => {
        this.loadScrolling();
    });
class SmoothScrollMenu {
    constructor(e) {
        (this.menuItems = document.querySelectorAll(e)), this.attachEvents(), this.hideMenuItemsWithoutSection();
    }
    attachEvents() {
        this.menuItems.forEach((e) => {
            const t = e.querySelector("a");
            t &&
                t.getAttribute("href") &&
                "#" !== t.getAttribute("href") &&
                t.addEventListener("click", (e) => this.handleMenuItemClick(e, t));
        });
    }
    handleMenuItemClick(e, t) {
        e.preventDefault();
        var n = t.getAttribute("href"),
            i = !0;
        const o = window.location.pathname + window.location.hash;
        if ((n.includes("/") && o !== n && ((window.location.href = n), (i = !1)), i)) {
            var s = document.getElementById(t.getAttribute("href").split("#")[1]);
            s && this.scrollToSection(s);
        }
    }
    scrollToSection(e) {
        this.smoothScrollTo(e);
    }
    smoothScrollTo(e) {
        window.scrollTo({ behavior: "smooth", top: e.offsetTop });
    }
    hideMenuItemsWithoutSection() {
        this.menuItems.forEach((e) => {
            const t = e.querySelector("a").getAttribute("href").split("#")[1];
            void 0 === t || "" === t || document.getElementById(t) || (e.style.display = "none");
        });
    }
}
document.addEventListener("DOMContentLoaded", function () {
    new SmoothScrollMenu(".header__inline-menu .menu-lv-1"),
        customElements.define("details-disclosure", DetailsDisclosure);
});
class DetailsDisclosure extends HTMLElement {
    constructor() {
        super(),
            (this.mainDetailsToggle = this.querySelector("details")),
            this.addEventListener("keyup", this.onKeyUp),
            this.mainDetailsToggle.addEventListener("focusout", this.onFocusOut.bind(this));
    }
    onKeyUp(e) {
        if ("ESCAPE" !== e.code.toUpperCase()) return;
        const t = e.target.closest("details[open]");
        if (!t) return;
        const n = t.querySelector("summary");
        t.removeAttribute("open"), n.focus();
    }
    onFocusOut() {
        setTimeout(() => {
            this.contains(document.activeElement) || this.close();
        });
    }
    close() {
        this.mainDetailsToggle.removeAttribute("open");
    }
}
class AccountIcon extends HTMLElement {
    constructor() {
        super(), (this.icon = this.querySelector(".icon"));
    }
    connectedCallback() {
        document.addEventListener("storefront:signincompleted", this.handleStorefrontSignInCompleted.bind(this));
    }
    handleStorefrontSignInCompleted(e) {
        e?.detail?.avatar && this.icon?.replaceWith(e.detail.avatar.cloneNode());
    }
}
customElements.define("account-icon", AccountIcon);
class PositiveVibesComponent extends HTMLElement {
    constructor() {
        super(), this.productPositiveVibes();
    }
    productPositiveVibes() {
        const e = this.querySelector(".text-vibes"),
            t = this.querySelectorAll(".text-vibes--child");
        let n = 0;
        if (t.length > 1) {
            const i = document.createElement("div");
            i.classList.add("text-vibes--child"), (i.innerHTML = t[0].innerHTML), e.appendChild(i);
            const o = e.querySelectorAll(".text-vibes--child");
            setInterval(() => {
                const t = o[n].offsetHeight;
                o.forEach((i, o) => {
                    (e.style.cssText = `transform: translateY(${t * -n}px); transition: all .5s ease;`),
                        0 == n && (e.style.cssText = `transform: translateY(${t * -n}px); transition: none;`);
                }),
                    (n = (n + 1) % o.length),
                    this.heightPositive();
            }, 3e3);
        }
    }
    heightPositive() {
        this.querySelector(".text-vibes");
        const e = this.querySelectorAll(".text-vibes--child");
        let t = 0;
        e.forEach((e) => {
            t = Math.max(t, e.querySelector("p").offsetHeight);
        }),
            (this.style.minHeight = t + "px"),
            e.forEach((e) => {
                e.style.minHeight = `${t}px`;
            });
    }
}
function checkTransparentHeader() {
    allowTransparent(),
        Shopify.designMode &&
            (document.addEventListener("shopify:section:load", allowTransparent),
            document.addEventListener("shopify:section:unload", allowTransparent),
            document.addEventListener("shopify:section:reorder", allowTransparent));
}
function allowTransparent() {
    document.querySelector(".shopify-section:first-child [allow-transparent-header]") ||
        document.querySelector("body").removeAttribute("allow-transparency");
}
document.addEventListener("DOMContentLoaded", () => {
    customElements.define("positive-vibes", PositiveVibesComponent);
}),
    document.addEventListener("DOMContentLoaded", function () {
        checkTransparentHeader();
    });
const PUB_SUB_EVENTS = {
    cartUpdate: "cart-update",
    quantityUpdate: "quantity-update",
    optionValueSelectionChange: "option-value-selection-change",
    variantChange: "variant-change",
    cartError: "cart-error",
};
let subscribers = {};
function subscribe(e, t) {
    return (
        void 0 === subscribers[e] && (subscribers[e] = []),
        (subscribers[e] = [...subscribers[e], t]),
        function () {
            subscribers[e] = subscribers[e].filter((e) => e !== t);
        }
    );
}
function publish(e, t) {
    subscribers[e] &&
        subscribers[e].forEach((e) => {
            e(t);
        });
}
class BulkAdd extends HTMLElement {
    constructor() {
        super(), (this.queue = []), (this.requestStarted = !1), (this.ids = []);
    }
    startQueue(e, t) {
        this.queue.push({ id: e, quantity: t });
        const n = setInterval(() => {
            this.queue.length > 0 ? this.requestStarted || this.sendRequest(this.queue) : clearInterval(n);
        }, 250);
    }
    sendRequest(e) {
        this.requestStarted = !0;
        const t = {};
        e.forEach((e) => {
            t[parseInt(e.id)] = e.quantity;
        }),
            (this.queue = this.queue.filter((t) => !e.includes(t)));
        (this.closest("quick-order-list") || this.closest("quick-add-bulk")).updateMultipleQty(t);
    }
    resetQuantityInput(e) {
        const t = this.querySelector(`#Quantity-${e}`);
        (t.value = t.getAttribute("value")), (this.isEnterPressed = !1);
    }
    setValidity(e, t, n) {
        e.target.setCustomValidity(n), e.target.reportValidity(), this.resetQuantityInput(t), e.target.select();
    }
    validateQuantity(e) {
        const t = parseInt(e.target.value),
            n = e.target.dataset.index;
        t < e.target.dataset.min
            ? this.setValidity(e, n, window.quickOrderListStrings.min_error.replace("[min]", e.target.dataset.min))
            : t > parseInt(e.target.max)
              ? this.setValidity(e, n, window.quickOrderListStrings.max_error.replace("[max]", e.target.max))
              : t % parseInt(e.target.step) != 0
                ? this.setValidity(e, n, window.quickOrderListStrings.step_error.replace("[step]", e.target.step))
                : (e.target.setCustomValidity(""), e.target.reportValidity(), this.startQueue(n, t));
    }
    getSectionsUrl() {
        return window.pageNumber
            ? `${window.location.pathname}?page=${window.pageNumber}`
            : `${window.location.pathname}`;
    }
    getSectionInnerHTML(e, t) {
        return new DOMParser().parseFromString(e, "text/html").querySelector(t).innerHTML;
    }
}
customElements.get("bulk-add") || customElements.define("bulk-add", BulkAdd);
